import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { secure, withParams } from 'utils/client';
import { LIST, tags, types } from '../consts';

const { REACT_APP_API_URL: baseUrl } = process.env;

const grantsAPI = createApi({
  reducerPath: 'grants',
  tagTypes: Object.values(types),
  baseQuery: fetchBaseQuery({ baseUrl }),
  endpoints: (build) => ({
    getGrants: build.query({
      query: (params) =>
        secure({
          method: 'GET',
          url: withParams('/grants', params),
        }),
      providesTags: [tags.GRANTS(LIST)],
    }),

    createGrant: build.mutation({
      query: (body) =>
        secure({
          method: 'POST',
          url: `/grants`,
          body,
        }),
      invalidatesTags: [tags.GRANTS(LIST)],
    }),

    updateGrant: build.mutation({
      query: ({ grant_id, body }) =>
        secure({
          method: 'PATCH',
          url: `/grants/${grant_id}`,
          body,
        }),
      invalidatesTags: [tags.GRANTS(LIST)],
    }),

    deleteGrant: build.mutation({
      query: (grant_id) =>
        secure({
          method: 'DELETE',
          url: `/grants/${grant_id}`,
        }),
      invalidatesTags: [tags.GRANTS(LIST)],
    }),
  }),
});

export default grantsAPI;
